// extracted by mini-css-extract-plugin
export var childrenContainer = "_3r-0";
export var virtualScrollArea = "_3r-1";